import type { ComponentProps } from "react"
import { cn } from "design/lib"
import Glyph from "./Glyph"

type Props = {
  glyph: ComponentProps<typeof Glyph>["variant"]
  size?: number
  className?: string
  flipX?: boolean
  flipY?: boolean
}

export default function Watermark({
  glyph,
  size = 192,
  className,
  flipX,
  flipY,
}: Props) {
  return (
    <div
      className={cn(
        "pointer-events-none absolute right-4 bottom-4 opacity-10",
        className,
      )}
    >
      <Glyph
        variant={glyph}
        size={size}
        className={cn(flipX && "-scale-x-100", flipY && "-scale-y-100")}
      />
    </div>
  )
}
